import "plugin_multi_wishlist/multiWishlist";